module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2339867"
    }
  }, [_c('b', [_vm._v("HEARTY MUSHROOM-BARLEY SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2340367"
    }
  }, [_c('b', [_c('i', [_vm._v("A real rib-sticker. Get a head start by cooking the barley the day before, then cool and refrigerate until needed.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2341367"
    }
  }, [_c('b', [_vm._v("Prep: 20 minutes Cook: 1 hour")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2341967"
    }
  }, [_vm._v("¾ cup pearl barley")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2342867"
    }
  }, [_vm._v("8 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2343167"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2343467"
    }
  }, [_vm._v("3 stalks celery, cut into ¼-inch-thick slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2344667"
    }
  }, [_vm._v("1 large onion (12 ounces), chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2344967"
    }
  }, [_vm._v("1½ pounds mushrooms, trimmed and thickly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2346367"
    }
  }, [_vm._v("2 tablespoons tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2346667"
    }
  }, [_vm._v("5 carrots, peeled and each cut lengthwise in half, "), _c('br'), _vm._v(" then crosswise into ¼-inch-thick slices")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2348167"
    }
  }, [_vm._v("2 cans (14½ ounces each) beef broth or")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2349267"
    }
  }, [_vm._v("3½ cups Brown Beef Stock")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2350467"
    }
  }, [_vm._v("¼ cup dry sherry")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2351367"
    }
  }, [_vm._v("1½ teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2352767"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 3-quart saucepan, combine barley and 4 cups water; heat to boiling over high heat. Reduce heat; cover and simmer 30 minutes. Drain.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2354067"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Meanwhile, in 5-quart Dutch oven, heat oil over medium-high heat. Add celery and onion; cook, stirring, until golden, about 10 minutes. Increase heat to high; add mushrooms and cook, stirring occasionally, until liquid has evaporated and mushrooms are lightly browned, 10 to 12 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2356667"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Reduce heat to medium-high; add tomato paste and cook, stirring, 2 minutes. Add barley, carrots, broth, sherry, salt, and remaining 4 cups water; heat to boiling. Reduce heat; cover and simmer until carrots and barley are tender, 20 to 25 minutes. Makes about 12 cups or 10 first-course servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2359167"
    }
  }, [_vm._v("Each serving: About 133 calories, 5g protein, 21g carbohydrate, 4g total fat (1g saturated), 1mg cholesterol, 684mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-943f55f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c70_r1.vue
// module id = 276
// module chunks = 0